import React from "react";

function HorizontalSeparator({ borderWidth, borderColor, borderStyle }) {
  return <div style={{ borderWidth, borderColor, borderStyle }} />;
}

export default HorizontalSeparator;
